import { gql } from '@apollo/client';

export const GET_PET_SERVICES = gql`
  query GetPetServices($userLocation: [Float!]!, $radiusInKm: Float!) {
    getPetServices(userLocation: $userLocation, radiusInKm: $radiusInKm) {
      _id
      userId
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      createdAt
      updatedAt
      language
    }
  }
`;

export const GET_PET_SERVICE = gql`
  query GetPetService($_id: ID!) {
    getPetService(_id: $_id) {
      _id
      userId
      title
      description
      imageUrl
      location {
        type
        coordinates
      }
      createdAt
      updatedAt
      language
      expiresAt
      extensionCount
      lastExtendedAt
    }
  }
`;

